import { MessageTypes } from "@/types/enums/message-types";
import { Unauthorized } from "@/types/api/responses";
import { useAuthStore } from "@/stores/Auth";
import { storeToRefs } from "pinia";
import pinia from "@/plugins/PiniaPlugin";

export type DataSyncEvent = {
    typeSignifier: string,
    eventType: MessageTypes,
    baseUrl?: string | undefined,
    corsOrigin?: string | undefined,
    authToken?: string | undefined | null,
    payload?: string | undefined
}

export function createDataSyncEvent( evtType: MessageTypes,
                                     payload?: string | undefined,
                                     serverBaseUri?: string | undefined,
                                     origin?: string | undefined,
                                     authToken?: string | undefined ): DataSyncEvent {
    const { isAuthenticated, authToken: jwt } = storeToRefs( useAuthStore( pinia ) );
    if ( !isAuthenticated.value ) {
        throw new Unauthorized();
    }

    const baseUrl: string = serverBaseUri ?? `${ import.meta.env.VITE_FLAGSHIP_BASE_URI }`;
    const corsOrigin: string = origin ?? `${ import.meta.env.VITE_ORIGIN }`;
    const token: string | null = authToken ?? jwt.value;

    return {
        typeSignifier: 'tmi_sync_evt',
        baseUrl: baseUrl,
        corsOrigin: corsOrigin,
        authToken: token,
        eventType: evtType,
        payload: payload
    };
}
